import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../../common/CCUtils"

export enum MentalAssets {
    BACKGROUND = "MentalBACKGROUND",
    CARPET = "MentalCARPET",
    MEAT_BOWL = "MentalMEAT_BOWL",
    PAVLOV = "MentalPAVLOV",
    COFFEE_ALONE = "MentalCOFFEE_ALONE",
    COFFEE_TOGETHER = "MentalCOFFEE_TOGETHER",
    COFFEE_ONLY = "MentalCOFFEE_ONLY",
    COFFEE = "MentalCOFFEE",

    AUDIO = "MentalAUDIO",

    DOG = "MentalDOG",
    DOG_TAIL = "MentalDOG_TAIL",
    DROOL = "MentalDROOL",
    BELL = "MentalBELL",
    THOUGHT_MEAT = "MentalTHOUGHT_MEAT",
    THOUGHT_BELL_MEAT = "MentalTHOUGHT_BELL_MEAT",
    THOUGHT_ECIG = "MentalTHOUGHT_ECIG",
    COFFEE_SMELL = "MentalCOFFEE_SMELL",
}

export function loadAssets(game: Phaser.Game) {
    game.load.image(MentalAssets.BACKGROUND, CCUtils.asset("addiction/mental-addiction/background.png"))
    game.load.image(MentalAssets.CARPET, CCUtils.asset("addiction/mental-addiction/carpet.png"))
    game.load.image(MentalAssets.MEAT_BOWL, CCUtils.asset("addiction/mental-addiction/meatbowl.png"))
    game.load.image(MentalAssets.PAVLOV, CCUtils.asset("addiction/mental-addiction/pavlov.png"))
    game.load.image(MentalAssets.COFFEE_ALONE, CCUtils.asset("addiction/mental-addiction/coffee-alone.png"))
    game.load.image(MentalAssets.COFFEE_TOGETHER, CCUtils.asset("addiction/mental-addiction/coffee-together.png"))
    game.load.image(MentalAssets.COFFEE_ONLY, CCUtils.asset("addiction/mental-addiction/coffee-only.png"))
    game.load.image(MentalAssets.COFFEE, CCUtils.asset("addiction/mental-addiction/coffee.png"))

    game.load.audio(MentalAssets.AUDIO, CCUtils.asset("addiction/mental-addiction/addiction-101-mental.mp3"))

    game.load.spritesheet(MentalAssets.DOG, CCUtils.asset("addiction/mental-addiction/dog-no-tail.png"), 567, 507)
    game.load.spritesheet(MentalAssets.DOG_TAIL, CCUtils.asset("addiction/mental-addiction/dog-tail.png"), 62, 73)
    game.load.spritesheet(MentalAssets.DROOL, CCUtils.asset("addiction/mental-addiction/drool.png"), 27, 112)
    game.load.spritesheet(MentalAssets.BELL, CCUtils.asset("addiction/mental-addiction/bell.png"), 250, 277)
    game.load.spritesheet(MentalAssets.THOUGHT_MEAT, CCUtils.asset("addiction/mental-addiction/thought-meat.png"), 235, 119)
    game.load.spritesheet(MentalAssets.THOUGHT_BELL_MEAT, CCUtils.asset("addiction/mental-addiction/thought-bell-meat.png"), 235, 119)
    game.load.spritesheet(MentalAssets.THOUGHT_ECIG, CCUtils.asset("addiction/mental-addiction/thought-ecig.png"), 235, 119)
    game.load.spritesheet(MentalAssets.COFFEE_SMELL, CCUtils.asset("addiction/mental-addiction/coffee-smoke.png"), 35, 56)
}
